<template>
  <LSection :use-margin="false">
    <template #body>
      <div class="chatbot">
        <div class="heading1">
          Quantum Career Chatbot
          <hr class="gradientLine" />
        </div>
        <LSection :use-margin="false">
          <template #body>
            <div class="text-justify">
              <p>
                Use the embedded chatbot below to explore quantum career paths,
                roles, and requirements. Ask in your own words or follow
                suggested prompts — answers draw on real job listings and adapt to
                your skills, interests, and location.
              </p>
              <br />
              <iframe
                :src="chatbotUrl"
                frameborder="0"
                class="w-full min-h-[700px] rounded-lg border border-gray-200"
                title="Quantum Career Chatbot"
              ></iframe>
              <p class="mt-4">
                If the embed does not load,
                <a
                  :href="chatbotUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="gradientText font-semibold underline"
                >
                  open the chatbot in a new tab
                </a>
                .
              </p>
            </div>
          </template>
        </LSection>
      </div>
    </template>
  </LSection>
</template>

<script>
import LSection from "@/components/layout/LSection.vue";
import { onMounted } from "vue";

const CHATBOT_URL = "https://staging.hybridintelligence.eu/quantum-career-bot/";

export default {
  components: {
    LSection,
  },
  setup() {
    const setHeadingColor = () => {
      const heading = document.getElementById("analysisHeader");

      if (heading !== null && heading?.classList) {
        heading.classList.add("text-white");
        heading.classList.remove("text-black");
      }
    };
    onMounted(() => {
      window.addEventListener("scroll", setHeadingColor);
    });
    return {
      chatbotUrl: CHATBOT_URL,
    };
  },
};
</script>

<style scoped></style>
